import SectionCell from "../../cell"
import { formatOrDash } from "../../../../utils"

interface Props {
  label: string
  value: number | string
}

const CurrencyValue = ({ label, value }: Props) => (
  <SectionCell label={label} value={formatOrDash(value)} className="!pt-0" />
)

export default CurrencyValue
